module.exports = __webpack_public_path__ + "fa-regular-400.woff2?b91d376b8d7646d671cd820950d5f7f1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/webfonts/fa-regular-400.woff2
// module id = 1452
// module chunks = 0